import { Outlet } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/feature/Breadcrumb";
import ScrollToTop from "@/components/feature/ScrollToTop";
import ScrollToTopOnNavigate from "@/components/feature/ScrollToTopOnNavigate";

export default function Layout() {
  return (
    <div className="min-h-screen bg-background-50 flex flex-col">
      <ScrollToTopOnNavigate />
      <Navbar />
      <Breadcrumb />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <ScrollToTop />
    </div>
  );
}